export default {
  title: {
    en: 'Enter your username'
  },

  description: {
    en: 'In order to save your score and show it on leaderboard we need your username.'
  },

  placeholder: {
    en: 'Your username'
  },

  error: {
    en: 'Please enter a unique username.'
  },

  submit: {
    en: 'Submit'
  }
};
